import axios from "axios";
import { CarriersListResponse } from "models/dto/CarriersListResponse";
import { QueryGridResponse } from "models/QueryGridResponse";
import { CarriersFilter } from "./useCarriersFilter";
import { appendCarrierFilterParams } from "./carrierFilterParams";

const exportPageSize = 500;

const fetchAllCarriers = async (carriersFilter: CarriersFilter) => {
  const carriers: CarriersListResponse[] = [];
  let total = Infinity;

  for (let page = 1; carriers.length < total; page++) {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: exportPageSize.toString(),
      sortField: carriersFilter.sortField,
      dir: carriersFilter.dir,
    });
    appendCarrierFilterParams(params, carriersFilter);

    const { data } = await axios.get<QueryGridResponse<CarriersListResponse>>(
      `/api/carriers/list?${params.toString()}`
    );

    if (!data.entities.length) break;
    carriers.push(...data.entities);
    total = data.filteredCount;
  }

  return carriers;
};

export default fetchAllCarriers;
